<template>
    <div id="navigation">
        <div class="panel-navigation">
            <div class="container">
                <div class="row row-navigation">
                    <div class="col-md-12">

                        <nav class="navbar navbar-default">
                            <div class="container-fluid">
                                <div class="navbar-header">
                                    <h1>
                                        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                                                data-target="#navbar-collapse-navigation" aria-expanded="false">
                                            <span class="sr-only">Toggle navigation</span>
                                            <span class="icon-bar"></span>
                                            <span class="icon-bar"></span>
                                            <span class="icon-bar"></span>
                                        </button>
                                        {{etapeBar.titre}}
                                    </h1>
                                </div>
                                <div class="navbar-header">
                                    <div class="row">
                                        <div class="col-sm-6 col-md-5">
                                            <div class="progression">ETAPE
                                                {{etapeBar.currentStep}}/{{etapeBar.lastStep}}
                                            </div>
                                            <div class="progress" style="margin-bottom:10px;">
                                                <div class="progress-bar" role="progressbar"
                                                     :aria-valuenow="etapeBar.valueNow"
                                                     :aria-valuemin="etapeBar.valueMin"
                                                     :aria-valuemax="etapeBar.valueMax" :style="etapeBar.width"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="collapse navbar-collapse" id="navbar-collapse-navigation">
                                        <div class="view-prestation collapse in">
                                            <div class="view-content">
                                                <div class="item-list">
                                                    <ul>
                                                        <li v-for="etape in etapes" v-bind:key="etape.id"
                                                            class="views-row">
                                                            <div class="views-field views-field-title">
                                                                <span class="field-content">
                                                                    <span :class="['etape', etape.active]">{{etape.nom}}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'Navbar',

  computed: {
    ...mapGetters({
      etapes: 'getEtapes',
      etapeBar: 'getEtapeBar',
    }),
  },

};
</script>

<style scoped>

</style>
